import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from '../../services/axios'
import { Container, Content } from './styles'
import treepayLogo from '../../assets/TREEPAY.png'
export default function EmailVerification() {
    const { id, token } = useParams()
    const [verified, setVerified] = useState(true)

    useEffect(() => {
        async function sendVerification() {
            try {
                await axios.put(`/verify/${id}/${token}`)
                setVerified(true)
            } catch (error) {
                setVerified(false)
            }
        }

        sendVerification()
    }, [id, token])
    return (
        <Container>
            <Content>
                <img src={treepayLogo} alt="Logo da treepay" />
                {verified ? (
                    <div>
                        <h1>Sucesso!</h1>
                        <p>Sua conta foi verifica!</p>
                        <p>
                            Agora você pode voltar para a página de{' '}
                            <a href="/login">login</a>
                        </p>
                    </div>
                ) : (
                    <div>
                        <h1>Ahh não!</h1>
                        <p>Aconteceu algum erro imprevisto!</p>
                    </div>
                )}
            </Content>
        </Container>
    )
}
